import { combineReducers } from '@reduxjs/toolkit';
import demoReducer from './slices/demo';
import { usersAPI } from './services/usersAPI';
import { teamsAPI } from './services/teamsAPI';
import { userDelegationsAPI } from './services/userDelegationsAPI';
import { groupsAPI } from './services/groupsAPI';
import { featuresAPI } from './services/featuresAPI';
import { applicationsAPI } from './services/applicationsAPI';
import { platformsAPI } from './services/platformsAPI';
import { rolesAPI } from './services/rolesAPI';

const rootReducer = combineReducers({
  demo: demoReducer,
  // `rtk-query` api reducers
  [usersAPI.reducerPath]: usersAPI.reducer,
  [teamsAPI.reducerPath]: teamsAPI.reducer,
  [userDelegationsAPI.reducerPath]: userDelegationsAPI.reducer,
  [groupsAPI.reducerPath]: groupsAPI.reducer,
  [featuresAPI.reducerPath]: featuresAPI.reducer,
  [applicationsAPI.reducerPath]: applicationsAPI.reducer,
  [platformsAPI.reducerPath]: platformsAPI.reducer,
  [rolesAPI.reducerPath]: rolesAPI.reducer,
});

export default rootReducer;
